import adminLayout from "./adminLayout";

export default { adminLayout };
